// TODO: Update to utilise chakra v3 segmented control after upgrade
import { Box, HStack, Text } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';

export type SegmentItem = {
  id: string;
  label: string;
  icon?: ReactNode;
  content?: ReactNode;
};

type Props = {
  segments: SegmentItem[];
  activeSegmentId: string;
  onSegmentChange: (segmentId: string) => void;
};

export const SegmentControl = ({
  segments,
  activeSegmentId,
  onSegmentChange,
}: Props): ReactElement => {
  return (
    <Box bg="background.canvas" borderRadius="10px" p="5px" display="flex" gap={0} width="100%">
      {segments.map((segment) => {
        const isActive = segment.id === activeSegmentId;
        return (
          <Box
            key={segment.id}
            as="button"
            onClick={() => onSegmentChange(segment.id)}
            flex="1"
            bg={isActive ? 'background.primary' : 'transparent'}
            borderRadius="m"
            px="15px"
            py="9px"
            height="35px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="5px"
            cursor="pointer"
            boxShadow={isActive ? '0px 0px 15px 0px rgba(0,0,0,0.04)' : 'none'}
            transition="all 0.2s"
            _hover={{
              bg: isActive ? 'background.primary' : 'background.canvas',
            }}
          >
            <HStack gap="5px" align="center">
              {segment.icon && (
                <Box
                  width="18px"
                  height="18px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  color={isActive ? 'text.primary' : 'text.tertiary'}
                >
                  {segment.icon}
                </Box>
              )}
              <Text
                textStyle="body.m.regular"
                color={isActive ? 'text.primary' : 'text.tertiary'}
                whiteSpace="nowrap"
                lineHeight="1.3"
              >
                {segment.label}
              </Text>
            </HStack>
          </Box>
        );
      })}
    </Box>
  );
};
